export const CLOSE_ICON_SIZE = '18px'

export const SHOW_OFFERS = 'Show Offers'

export const CLEAR_ALL = 'Clear All'
